export function CancellationPolicy() {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Cancellation Policy</h1>
        <p className="legal-updated">Last updated: February 14, 2026</p>

        <div className="legal-content">
          <h2>Overview</h2>
          <p>
            You may cancel your CryptoGuardians subscription at any time, for any reason. There are no
            cancellation fees.
          </p>

          <h2>How to Cancel</h2>
          <p>You can cancel your subscription through any of the following methods:</p>
          <ul>
            <li>
              <strong>Account Center:</strong> Log in to your CryptoGuardians account and manage your
              subscription from the <a href="/wallet">Account Center</a>.
            </li>
            <li>
              <strong>Email:</strong> Send a cancellation request to{' '}
              <a href="mailto:support@cryptoguardians.io">support@cryptoguardians.io</a>.
            </li>
            <li>
              <strong>Stripe Customer Portal:</strong> If enabled, you may manage your subscription
              directly through the Stripe customer portal linked from your account.
            </li>
          </ul>

          <h2>What Happens When You Cancel</h2>
          <ul>
            <li>Your subscription remains active until the end of your current billing cycle.</li>
            <li>You will not be charged for subsequent billing periods after cancellation.</li>
            <li>
              You retain full access to all CryptoGuardians features until your current billing period
              expires.
            </li>
            <li>
              No retroactive refunds are issued beyond the 14-day refund window described in our{' '}
              <a href="/refund-policy">Refund Policy</a>.
            </li>
          </ul>

          <h2>Reactivation</h2>
          <p>
            You can resubscribe at any time by visiting CryptoGuardians and starting a new subscription.
            If you reconnect with the same wallet address, your previous account data will be available.
          </p>

          <h2>Changes to This Policy</h2>
          <p>
            We reserve the right to update this Cancellation Policy at any time. Changes will be posted
            on this page with an updated effective date.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about cancellation? Email us at{' '}
            <a href="mailto:support@cryptoguardians.io">support@cryptoguardians.io</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
